import React from "react";
import { useTranslation } from "react-i18next";
import cx from "clsx";
import { Row, Col } from "reactstrap";

export interface SessionProps {
  device_type: "MOBILE" | "DESKTOP" | "TABLET";
  ip?: string;
  signed_in_time?: string;
  logged_out_time?: string;
}

export default ({ device_type, ip, signed_in_time, logged_out_time }: SessionProps) => {
  const { t } = useTranslation();

  const isActive = !logged_out_time;

  const deviceIcon = {
    MOBILE: "mdi-cellphone",
    DESKTOP: "mdi-laptop",
    TABLET: "mdi-tablet"
  };

  return (
    <div className="card-box mb-1" style={{ position: "relative" }}>
      <Row className="align-items-center">
        <Col sm={8}>
          <div className="media">
            <div className="media-image">
              <i className={cx("mdi", "mdi-36px", "mr-3", deviceIcon[device_type])} />
            </div>
            <div className="media-body">
              <h4 className="mt-0 mb-1 font-16">
                {ip}{" "}
                <div
                  className={cx("badge", "font-10", "p-1", "ml-1", { "bg-success": isActive, "bg-danger": !isActive })}>
                  {isActive ? t("global.active") : t("global.inactive")}
                </div>
              </h4>
              <p className="mb-0">
                <b>{isActive ? "Signed in" : "Logged out"}:</b> {isActive ? signed_in_time : logged_out_time}
              </p>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};
